import type { ReactNode } from "react";

type PlatformPageHeaderProps = {
  eyebrow?: string;
  title: string;
  description?: string;
  action?: ReactNode;
  secondaryAction?: ReactNode;
  className?: string;
};

export function PlatformPageHeader({
  eyebrow = "MinistryIQ Platform",
  title,
  description,
  action,
  secondaryAction,
  className = "",
}: PlatformPageHeaderProps) {
  return (
    <header
      className={[
        "flex flex-col gap-5 lg:flex-row lg:items-start lg:justify-between",
        className,
      ].join(" ")}
    >
      <div className="min-w-0">
        {eyebrow && (
          <p className="text-sm font-semibold uppercase tracking-[0.18em] text-indigo-600">
            {eyebrow}
          </p>
        )}

        <h1 className="mt-2 text-3xl font-bold tracking-tight text-slate-950">
          {title}
        </h1>

        {description && (
          <p className="mt-2 max-w-3xl text-base leading-7 text-slate-600">
            {description}
          </p>
        )}
      </div>

      {(action || secondaryAction) && (
        <div className="flex shrink-0 flex-col gap-3 sm:flex-row">
          {secondaryAction}
          {action}
        </div>
      )}
    </header>
  );
}